import { Map } from 'immutable';

import { getConnectedShopIds } from '@/utils/product/getConnectedShopIds';
import { shapeKeywordsForApp } from '@/utils/product/shapeAttributes';
import { updateListingScore } from '@/utils/product/score';
import { getPublishStatus } from '@/utils/listings/statuses';
import { areComplete } from '@/utils/product/isComplete';
import { newProduct } from '@/utils/product/new';
import { sortShops } from '@/utils/product/shapeForApp';
import { getSize } from '@/utils/iterable/getSize';

import { PUBLISH_ACTION } from '@/constants/listings';
import { SHOPIFY, EBAY } from '@/constants/channels';
import { ATTRIBUTE } from '@/constants/attributes';
import { EMPTY } from '@/constants';
import { NEW } from '@/constants/product';

function newEdit({ channel, shopId } = {}) {
  return Map({
    channel,
    isComplete: false,
    linkId: null,
    products: EMPTY.MAP,
    productId: NEW,
    shops: EMPTY.LIST,
    shopId,
    title: 'New listing',
  });
}

export function editNewProduct({ data, product, shopId, userFeatures, userShops }) {
  const channel = userShops.getIn(['byId', shopId, 'channel']);
  const isVelaOnlyShop = userShops.getIn(['byId', shopId, 'isVelaOnlyShop']);
  let result = (getSize(data) ? data : newEdit({ channel, shopId }));

  const shops = result
    .get('shops')
    .push(shopId)
    .sort(
      sortShops({
        first: result.get('shopId'),
        prioritized: getConnectedShopIds(result.get('products')),
        sorted: userShops.get('options'),
      })
    );

  result = result
    .set('activeShopId', shopId)
    .set('shops', shops)
    .setIn(['statuses', shopId], getPublishStatus({ action: PUBLISH_ACTION.PUBLISH, channel, isVelaOnlyShop }))
    .setIn(['products', shopId], (product || newProduct({ channel, userFeatures })).set('shopId', shopId));

  if (channel === SHOPIFY || channel === EBAY) {
    result = result.setIn(['products', shopId, ATTRIBUTE.KEYWORDS], shapeKeywordsForApp());
  }

  result = result.setIn(['products', shopId],
    updateListingScore({
      product: result.getIn(['products', shopId]),
      shop: userShops.getIn(['byId', shopId]),
      userFeatures,
    })
  );

  return result.set('isComplete', areComplete(result.get('products')));
}
